<app-handler-items
    (listItemComplete)="saveInput($event)"
    [itemsData]="minStockData"
    [addNewItem]="true"
    [addProvider]="true"
    [showPurchaseOrder]="showComboPurchaseOrder"
    [titleDialog]="'Entradas Almacén'"
    [replyRoute]="'almacen/entradas_inventario'"
    [editCostItem]="true"
    [urlItemCombo]="urlGetItemsWarehouse"
 >
</app-handler-items>
